"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponErrors = void 0;
var interfaces_1 = require("../common/interfaces");
exports.CouponErrors = {
    INVALID_COUPON: {
        code: 'COUPON-000',
        message: 'Invalid Coupon',
        type: interfaces_1.ErrorType.INLINE,
    },
    NON_APPLICABLE_COUPON: {
        code: 'COUPON-001',
        message: 'Sorry, this coupon is only applicable to (certain sales of subscriptions)',
        type: interfaces_1.ErrorType.INLINE,
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/couponAPI/constants.js
// module id = 3400
// module chunks = 11